module.exports = {"meta":"Imprint"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/imprint.json
// module id = KSF4
// module chunks = 1